// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '건일바이오팜',
  targetSheetName: '품목리스트',
  headerRowIndex: 1,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  requiredHeaders: [
    '번호',
    '효능군',
    '품목명',
    '성분',
    '분류명',
    '① 기본 수수료',
    '② 특별 수수료',
    '최종수수료 ①+②',
    '약가',
    '보험청구코드',
    '비고',
    '대조의약품',
  ],
  columnMapping: {
    drugName: '품목명',
    commissionRate: '① 기본 수수료',
    price: '약가',
    drugCode: '보험청구코드',
    commissionNote: '비고',
  },
});
